const t=(t,n)=>Math.abs(t-n);function n(n,o){const r=t(n.x,o.x),s=t(n.y,o.y);return Math.sqrt(r**2+s**2)}export{t as distance,n as distance2D};
